import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Link from '@veeva/corgix/link';
import useMessageService from '../services/i18n/useMessageService';
import { isMobile } from '../services/DeviceInformation';
import getTargetAttribute from '../services/getTargetAttribute';

const propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    onSwitchUser: PropTypes.func,
    showSwitchUser: PropTypes.bool,
    username: PropTypes.string,
};

const UsernameMask = ({ firstName, lastName, onSwitchUser, showSwitchUser = true, username }) => {
    const [[switchUserLabel = 'Switch user']] = useMessageService(['login.switch_user']);
    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                font-size: 18px;
            `}
        >
            <span
                css={css`
                    margin-bottom: 8px;
                    text-align: left;
                `}
            >
                {firstName} {lastName}
            </span>
            <span
                css={[
                    css`
                        margin-bottom: 12px;
                    `,
                    isMobile() &&
                        css`
                            margin-bottom: 16px;
                        `,
                    showSwitchUser &&
                        css`
                            margin-bottom: 8px;
                        `,
                ]}
            >
                {username}
            </span>
            {showSwitchUser && (
                <Link
                    data-target={getTargetAttribute('switch-user')}
                    css={({ blue }) => css`
                        font-size: 18px;
                        font-weight: normal;
                        margin-bottom: 1rem;

                        :hover {
                            color: ${blue};
                        }
                    `}
                    onClick={onSwitchUser}
                >
                    {switchUserLabel}
                </Link>
            )}
        </div>
    );
};

UsernameMask.propTypes = propTypes;

export default UsernameMask;
